import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

//assets
import { MinusIcon, PlusIcon } from 'assets/icons';
import { FieldLabel } from 'common/components/form/Wrapper/FieldLabel';
//styles
import { Flex } from 'components/styled/Flex';
import { FormGroup } from 'components/styled/Form.styled';

//components
import ErrorField from '../ErrorField';

import { CounterInput, CounterWrapper, Description, IconWrapper } from './index.styled';

const CounterField = ({
  description,
  name,
  value,
  setFieldValue,
  disabled,
  width,
  minValue = 0,
  maxValue,
  mb,
  counterFieldWithBorder,
  label,
  isRequired,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  const isMin = minValue !== undefined && value <= minValue;
  const isMax = maxValue !== undefined && value >= maxValue;

  const incCurrentValue = fieldName => {
    if (isMax) {
      return;
    }

    if (value < minValue) {
      setFieldValue(fieldName, minValue);

      return;
    }

    setFieldValue(fieldName, value + 1);
  };

  const decCurrentValue = fieldName => {
    if (isMin) {
      return;
    }

    if (value > maxValue) {
      setFieldValue(fieldName, maxValue);

      return;
    }

    setFieldValue(fieldName, value - 1);
  };

  return (
    <FormGroup mb={mb}>
      {counterFieldWithBorder && <FieldLabel label={t(label)} isRequired={isRequired} />}

      <CounterWrapper
        width={width}
        disabled={disabled}
        counterFieldWithBorder={counterFieldWithBorder}
      >
        {description && <Description>{description}</Description>}

        <Flex gap="0.5rem" justifyContent={counterFieldWithBorder && 'space-between'}>
          {!disabled && (
            <IconWrapper
              disabled={isMin}
              counterFieldWithBorder={counterFieldWithBorder}
              onClick={() => decCurrentValue(name)}
            >
              <MinusIcon stroke={isMin ? '#e8e8e8' : '#969a9e'} />
            </IconWrapper>
          )}
          <CounterInput name={name} type="number" />
          {!disabled && (
            <IconWrapper
              disabled={isMax}
              counterFieldWithBorder={counterFieldWithBorder}
              onClick={() => incCurrentValue(name)}
            >
              <PlusIcon stroke={isMax ? '#e8e8e8' : '#969a9e'} />
            </IconWrapper>
          )}
        </Flex>
        <ErrorMessage name={name} component={ErrorField} />
      </CounterWrapper>
      {errorMessage && <ErrorField>{errorMessage}</ErrorField>}
    </FormGroup>
  );
};

CounterField.propTypes = {
  description: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  mb: PropTypes.string,
  counterFieldWithBorder: PropTypes.bool,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default CounterField;
